<template>
  <Layout>
    <PageHeader :title="title" :items="items" /> 
    <div class="row">
        <div class="col-lg-12 col-sm-12 mb-3">
          <div class="card p-4">
           <div class="row">
            <div class="col-12 text-center m-5">
              *Comming Soon
            </div>
          </div>     
          </div>
       </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
export default {
  page: {
    title: "Tools Youtube",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Youtube",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Youtube",
          active: true
        }
      ]
    }
  },
  computed: {
  },
  methods:{
  
  },
  mounted(){
  }
};
</script>

<style scoped>
.loading{
  padding-top:20%;
  padding-bottom:20%;
}
</style>